import styled from 'styled-components';

import Color from '../../styles/color';

export const Container = styled.div`
  display: flex;
  padding: 16px;
  background-color: ${Color.primary};
  border-radius: 4px;
`;
export const Icon = styled.img`
  width: 24px;
  height: 24px;
  margin-right: 12px;
`;

export const Content = styled.p`
  color: ${Color.white};
  font-weight: 400;
  font-size: 15px;
  line-height: 24px;
`;
